/**
 * Cart API Reducer
 *
 * Gestisce stato carrello integrato con backend Laravel
 */

import {
  LOAD_CART_REQUEST,
  LOAD_CART_SUCCESS,
  LOAD_CART_FAILURE,
  ADD_TO_CART_REQUEST,
  ADD_TO_CART_SUCCESS,
  ADD_TO_CART_FAILURE,
  UPDATE_CART_SUCCESS,
  REMOVE_FROM_CART_SUCCESS,
  CLEAR_CART_SUCCESS,
  MERGE_CART_SUCCESS,
} from '../actions/cartActions';

const initialState = {
  items: [],
  total: 0,
  itemsCount: 0,
  loading: false,
  error: null,
  sessionId: localStorage.getItem('cart_session_id') || null,
};

const cartAPIReducer = (state = initialState, action) => {
  switch (action.type) {

    // ==================== LOAD CART ====================
    case LOAD_CART_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case LOAD_CART_SUCCESS:
      return {
        ...state,
        loading: false,
        items: action.payload.items || [],
        total: action.payload.total || 0,
        itemsCount: action.payload.items_count || 0,
      };

    case LOAD_CART_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // ==================== ADD TO CART ====================
    case ADD_TO_CART_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case ADD_TO_CART_SUCCESS:
      return {
        ...state,
        loading: false,
      };

    case ADD_TO_CART_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // ==================== UPDATE CART ====================
    case UPDATE_CART_SUCCESS:
      return {
        ...state,
        items: state.items.map(item =>
          item.id === action.payload.itemId
            ? { ...item, quantity: action.payload.quantity }
            : item
        ),
      };

    // ==================== REMOVE FROM CART ====================
    case REMOVE_FROM_CART_SUCCESS:
      return {
        ...state,
        items: state.items.filter(item => item.id !== action.payload),
      };

    // ==================== CLEAR CART ====================
    case CLEAR_CART_SUCCESS:
      return initialState;

    // ==================== MERGE CART ====================
    case MERGE_CART_SUCCESS:
      return {
        ...state,
        // Carrello verrà ricaricato con loadCart() subito dopo
      };

    default:
      return state;
  }
};

export default cartAPIReducer;
